var map = {
	"./5c592468-4e4a-4732-b590-93644df62cee.jpg": 2499,
	"./AboutUsImages/AboutUs1.webp": 3766,
	"./AboutUsImages/AboutUs2.webp": 8023,
	"./AboutUsImages/AboutUs3.webp": 4324,
	"./AboutUsImages/AboutUs4.webp": 405,
	"./AboutUsImages/AboutUsVideo.mp4": 1553,
	"./AboutUsImages/Spring-onions.webp": 8980,
	"./CertificeImages/brc.webp": 5994,
	"./CertificeImages/gap.webp": 3131,
	"./CertificeImages/grasp.webp": 6544,
	"./CertificeImages/iso.webp": 5422,
	"./CertificeImages/sedex.webp": 9806,
	"./ContactImages/onions4.webp": 9413,
	"./Onions.mp4": 7383,
	"./Onions3.mp4": 5224,
	"./ProductsImages/products.webp": 805,
	"./PurpuLogo.jpg": 7923,
	"./RedOnion.mp4": 6389,
	"./Sweet-potatoes.mp4": 6029,
	"./TUT_PRODUCE_Black_Logo_2400x1800-removebg-preview.png": 2477,
	"./ValuesImages/excellence.webp": 9905,
	"./ValuesImages/groups.webp": 6315,
	"./ValuesImages/sustainability.webp": 8434,
	"./ValuesImages/values-field.webp": 9712,
	"./ValuesImages/values-header.webp": 733,
	"./ValuesImages/values5.webp": 1124,
	"./ValuesImages/values6.webp": 1489,
	"./ValuesImages/values7.webp": 1462,
	"./ValuesImages/values8.webp": 9635,
	"./arrow-right.webp": 7808,
	"./bg.webp": 9373,
	"./bg2.webp": 6013,
	"./facebook.webp": 7422,
	"./field.webp": 5614,
	"./golden-onions-calendar.png": 5825,
	"./golden-onions.webp": 6432,
	"./linkedin.webp": 3172,
	"./mail.webp": 4145,
	"./onion-field.webp": 9778,
	"./onion-field2.webp": 9004,
	"./onion-field3.webp": 9247,
	"./onions-basket.webp": 8157,
	"./phone.webp": 6130,
	"./products.webp": 8670,
	"./red-onions-calendar.png": 5385,
	"./redonion.webp": 4586,
	"./spring-onions-calendar.png": 2121,
	"./spring-onions.webp": 2628,
	"./sweet-potato.webp": 2322,
	"./sweet-potatoes-calendar.png": 5373,
	"./tut-primary.png": 3340,
	"./tut-primary.webp": 6144,
	"./tut-produce-without-slogan.webp": 2384,
	"./tut-secondary.png": 8356,
	"./white-logo.png": 5293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;